import "../../styles/about.css";

import React from "react";

interface ImageCard extends React.HTMLAttributes<HTMLButtonElement> {
  images: string[];
  imageAspectRatio?: number;
}

const autoGrideLayout: Record<number, string[]> = {
  1: ["1 / 1 / 3 / 3"],
  2: ["1 / 1 / 3 / 2", "1 / 2 / 3 / 3"],
  3: ["1 / 1 / 3 / 2", "1 / 2 / 2 / 3", "2 / 2 / 3 / 3"],
  4: ["1 / 1 / 2 / 2", "1 / 2 / 2 / 3", "2 / 1 / 3 / 2", "2 / 2 / 3 / 3"],
};

const TextInput: React.FC<ImageCard> = ({
  images = [],
  imageAspectRatio = 1,
}) => {
  return (
    <>
      <div className={`plush-card ${images.length === 0 && "no-item"}`}>
        {images.length > 0 ? (
          <>
            {images.map((image, index) => {
              return (
                <img
                  key={image}
                  src={image}
                  className="card-image"
                  style={{
                    gridArea: autoGrideLayout[images.length][index],
                    aspectRatio: imageAspectRatio,
                  }}
                />
              );
            })}
          </>
        ) : (
          <div>0 item</div>
        )}
      </div>
      <style jsx>{`
        .plush-card {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-template-rows: repeat(2, 1fr);
          width: 100%;
          height: 100%;

          > img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            aspect-ratio: 1;
          }

          &.no-item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            border: 1px solid #e7e7e7;
            background: #f7f7f7;
          }
        }
      `}</style>
    </>
  );
};

export default TextInput;
